import React, {useState, useEffect, useRef} from 'react'
import BaseModal from '../Dialog/BaseModal'
import CowTagbyId from '../CowTagbyId/Cowtagbyid';
import {Stack, TextField, Button } from '@mui/material';
import { useToast } from '../Toast/ToastContext';

const SelectCow = ({
    openForm,
    ShowForm,
    onSubmit,
    ExistingList
})=>{
const [cows, setCows]=useState("");
const [cowlist, setCowList]=useState(ExistingList.split(","));
const [cowstring, setCowString] = useState(ExistingList);

const showToast = useToast();
const field1Ref = useRef(null);

const handlecowtag=(data)=>{
    // console.log(data);
    const idText = data.CowId;
    var existingtext = cowstring.toString();
    var index = cowlist.indexOf(idText.toString());
    // console.log(cowlist);
    // console.log(existingtext);
    // console.log("index " + index.toString());
    if (index === -1) {
    const cowlistlength = existingtext.length;
    console.log(cowstring);
    // console.log(cowlistlength);
  
    if(cowlistlength > 0){
      setCows(existingtext + "," + idText);
      setCowString(existingtext + "," + idText);
    } else {
        setCows(idText);
        setCowString(idText);
    }

          setCowList([...cowlist, idText.toString()]);
          // setCows("");
  } else {
    showToast(`Cow ${data.Tag} already exists` , "error");
    // console.log(idText + " Id already exists")
  }
// console.log(idText);

field1Ref.current.focus();

}
    return <>
      <BaseModal 
    open={openForm} 
    handleClose={ShowForm} 
    title="Select Cow"
    actions={
      <>
      <Button onClick={() => ShowForm(false)}>Cancel</Button>
      <Button color="primary" variant="contained" onClick={()=>{
        onSubmit(cowstring);
        // setCows("");
        ShowForm(false);
      }}>Confirm</Button>
    </>
    }
  >
    <Stack spacing={2}>
      <TextField label="Cow Ids" fullWidth value={cows} inputRef={field1Ref}  />
      <CowTagbyId onSelect={handlecowtag}/>
    </Stack>
  </BaseModal>    
    </>
}

export default SelectCow;